{
  "live": {
    "title": "Your question made it! 🌟",
    "cta": "See your question"
  },
  "card": {
    "title": "Got a burning question?",
    "subtitle": "Think of a great question and our team might add it to the CuriPop library!",
    "cta": "Submit a Question"
  },
  "submitted": {
    "title": "You submitted a question this week! 🎉",
    "next": "Come back on {date} to submit another one."
  },
  "form": {
    "validation": "Your question needs to be at least 10 characters.",
    "error": "Something went wrong. Please try again.",
    "placeholder": "What's your question?",
    "counter": "{count} / 500",
    "submitting": "Submitting…",
    "submit": "Submit my question!",
    "cancel": "Cancel"
  },
  "thanks": {
    "title": "Thanks for your curiosity!",
    "subtitle": "We loved reading your question. Our team will take a look — we read every single one.",
    "next": "You can submit another question next Monday."
  }
}
